/* =========================================
   GLOBAL ANIMATIONS (Loaded on EVERY page)
   ========================================= */
document.addEventListener('DOMContentLoaded', () => {
    if (window.foucTimeout) {
        clearTimeout(window.foucTimeout);
    }
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
    gsap.registerPlugin(ScrollTrigger);

    let mm = gsap.matchMedia();

    mm.add("(prefers-reduced-motion: no-preference)", () => {
        // 1. GLOBAL SECTION HEADERS
    gsap.utils.toArray('.section-header:not(.fees-header .section-header):not(.tour-intro .section-header)').forEach(header => {
        gsap.fromTo(header.children,
            { opacity: 0, y: 20 },
            {
                opacity: 1, 
                y: 0, 
                duration: 0.8, 
                stagger: 0.15, 
                ease: 'power3.out',
                scrollTrigger: { trigger: header, start: 'top 90%' }
            }
        );
    });

    // 2. PRE-FOOTER CTA
    if (document.querySelector('.pre-footer')) {
        gsap.fromTo('.pre-footer .container > *',
            { opacity: 0, y: 20 },
            {
                opacity: 1, y: 0, duration: 0.8, stagger: 0.15, ease: 'power3.out',
                scrollTrigger: { trigger: '.pre-footer', start: 'top 90%' }
            }
        );
    }

    // 3. FOOTER COLUMNS
    if (document.querySelector('.site-footer')) {
        gsap.fromTo('.footer-col',
            { opacity: 0, y: 30 },
            {
                opacity: 1, y: 0, duration: 0.8, stagger: 0.15, ease: 'power3.out',
                scrollTrigger: { trigger: '.site-footer', start: 'top 95%' }
            }
        );
    }

    // 4. DRAW-IN CRAYON SVG PATHS
    const crayonPaths = document.querySelectorAll('.crayon-svg path:not(.map-node .crayon-svg path):not(.hero-actions .crayon-svg path)');
    
    crayonPaths.forEach(path => {
        const length = path.getTotalLength();
        
        gsap.set(path, {
            strokeDasharray: length,
            strokeDashoffset: length,
            opacity: 0
        });
        
        const isArrowLine = path.classList.contains('arrow-line');
        const isArrowTip = path.classList.contains('arrow-tip');
        
        let drawDuration = 1.2; 
        let drawDelay = 0;
        
        if (isArrowLine) {
            drawDuration = 1.6;
        } else if (isArrowTip) {
            drawDuration = 0.4;
            drawDelay = 1.6; 
        }
        
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: path,
                start: 'top 90%'
            }
        });
        
        tl.to(path, { opacity: 1, duration: 0.01 }, drawDelay + 0.5)
          .to(path, { strokeDashoffset: 0, duration: drawDuration, ease: 'power2.out' });
    });
    // 5. 404 PAGE CONTENT
    if (document.querySelector('.error-404')) {
        gsap.fromTo('.error-404 .container > *',
            { opacity: 0, y: 20 },
            {
                opacity: 1, y: 0, duration: 0.8, stagger: 0.15, ease: 'power3.out',
                scrollTrigger: { trigger: '.error-404', start: 'top 90%' }
            }
        );
    }

    // Stop mobile URL bar from breaking animations when it hides on scroll
    ScrollTrigger.config({ ignoreMobileResize: true });
    }); // End matchMedia
});
